import { render, staticRenderFns } from "./PreScoreConversionCard.vue?vue&type=template&id=05065e76&"
import script from "./PreScoreConversionCard.vue?vue&type=script&lang=js&"
export * from "./PreScoreConversionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports